module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-05.fa4ce398.png";